import {
  IconButton,
  IconButtonProps,
} from '@chakra-ui/react';

export const CarouselIconButton = (props: IconButtonProps) => (
  <IconButton
    fontSize="2xl"
    display={{ base: "inline-flex", md: "none" }}
    isRound
    zIndex="10"
    top="50%"
    transform="translateY(-50%);"
    position="absolute"
    bg="blackAlpha.400"
    color="white"
    stroke="1px"
    _hover={{
      opacity: '1',
    }}
    _active={{
      opacity: '1',
    }}
    _focus={{ boxShadow: 'inerhit' }}
    _focusVisible={{ boxShadow: 'outline' }}
    {...props}
  />
);
